function Home() {
  return (
    <div>
      <main className="flex flex-col items-center justify-start min-h-screen px-4 py-10 bg-white text-gray-800 font-sans">
        <section className="container mx-auto mt-6 px-4 text-right">
          <h1 className="text-3xl font-extrabold text-orange-500 mb-6">
            سداد قروض وتمويل شخصي شرعي
          </h1>

          <div className="flex flex-col lg:flex-row gap-8">
            {/* صور */}
            <div className="w-full lg:w-1/3">
              <img
                src="/images/WhatsApp Image 2025-11-23 at 4.07.44 PM.jpeg"
                alt="إعلان سداد قروض"
                width={400}
                height={500}
                className="rounded shadow-md mb-4"
              />
              {/* <img
                src="/images/WhatsApp Image 2025-05-13 at 1.46.50 PM (1).jpeg"
                alt="إعلان سداد قروض"
                width={400}
                height={500}
                className="rounded shadow-md mb-4"
              />
              <img
                src="/images/WhatsApp Image 2025-05-13 at 1.46.50 PM.jpeg"
                alt="إعلان تمويل"
                width={400}
                height={500}
                className="rounded shadow-md"
              /> */}
            </div>

            {/* المحتوى */}
            <div className="w-full lg:w-2/3 text-lg leading-relaxed space-y-6">
              <section>
                <h2 className="text-2xl font-bold mb-2">من نحن؟</h2>
                <p>
                  مكتب أبو سلمان يتمتع بخبرة طويلة في مجال التمويل وسداد القروض.
                  نحرص على تقديم حلول شرعية وآمنة للأفراد والموظفين في القطاعين
                  الحكومي والخاص، مع التزامنا بالسرية والشفافية.
                </p>
                <p>
                  نهدف إلى مساعدتك في التخلص من التعثرات وتحقيق الاستقرار المالي
                  بأسرع وقت.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-orange-500">خدماتنا</h2>
                <ul className="list-disc pr-5 space-y-1">
                  <li>سداد القروض البنكية والتعثرات القديمة والجديدة.</li>
                  <li>استخراج تمويل حتى 36 راتب من جهات معتمدة.</li>
                  <li>تمويل بدون كفيل للموظفين الحكوميين والقطاع الخاص.</li>
                  <li>سداد سمة وإزالة إيقاف الخدمات القضائية.</li>
                  <li>تمويل مشاريع العمل الحر حتى 120 ألف ريال.</li>
                  <li>إعادة جدولة القروض وتخفيف الأقساط الشهرية.</li>
                  <li>استشارات مالية شرعية ومجانية.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-orange-500">
                  مزايا التعامل معنا
                </h2>
                <ul className="list-disc pr-5 space-y-1">
                  <li>حلول شرعية 100% بدون ربا.</li>
                  <li>إنجاز خلال 24 - 48 ساعة.</li>
                  <li>سرية تامة في التعامل.</li>
                  <li>إمكانية التواصل عن بعد دون حضور.</li>
                  <li>دعم متواصل طوال الأسبوع.</li>
                  <li>نسبة قبول عالية للطلبات.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-orange-500">
                  لماذا تختارنا؟
                </h2>
                <p>
                  لأننا نقدم حلولاً حقيقية بعيداً عن الوعود الزائفة. نمتلك شبكة
                  علاقات قوية مع جهات التمويل في المملكة، ونسعى لتحقيق رضاك
                  بأمان وموثوقية.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-orange-500">
                  تواصل معنا
                </h2>
                <p>
                  اتصل الآن على <strong>0509482139</strong> أو تواصل عبر{" "}
<a
  href="https://wa.me/9660509482139"
  target="_blank"
  rel="noopener noreferrer"
  className="text-green-600 font-semibold"
>
  واتساب
</a>

                  للحصول على استشارة مجانية وخدمة فورية.
                </p>
              </section>
            </div>
          </div>
        </section>

        {/* أزرار الاتصال الثابتة */}
        <a
          href="tel:+966509482139"
          className="fixed bottom-6 right-6 z-50"
          rel="nofollow"
          aria-label="اتصل بمكتب أبو سلمان"
        >
          <img src="/images/4367049.png" alt="اتصال" width={58} height={58} />
        </a>

        <a
          href="https://wa.me/9660509482139"
          target="_blank"
          rel="noopener noreferrer nofollow"
          aria-label="تواصل عبر واتساب"
          className="fixed bottom-6 left-6 z-50"
        >
          <img src="/images/whatsapp.png" alt="واتساب" width={58} height={58} />
        </a>

        {/* محتوى مخفي لتحسين السيو */}
        <section className="hidden lg:block mt-10 text-sm text-gray-600">
          <p>
            نقدم خدماتنا في كافة مناطق المملكة مثل:{" "}
            <strong>
              الرياض، جدة، مكة، الدمام، المدينة، تبوك، أبها، خميس مشيط، الطائف،
              القصيم، حائل، الباحة
            </strong>{" "}
            وغيرها. هل تبحث عن <strong>تسديد قروض الطائف</strong> أو{" "}
            <strong>تسديد قروض الرياض</strong> أو{" "}
            <strong>سداد قروض في الدمام</strong>؟ مكتب أبو سلمان هو خيارك الأمثل
            لتقديم أفضل حلول السداد والتمويل الشرعي.
          </p>
        </section>
      </main>
    </div>
  );
}

export default Home;
